import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { FeedbackButton } from './components/FeedbackButton';
import { useAuth } from './contexts/AuthContext';
import { useLang } from './contexts/LangContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import FichajesPage from './pages/FichajesPage';
import EmpleadosPage from './pages/EmpleadosPage';
import AnalisisPage from './pages/AnalisisPage';
import AnomaliasPage from './pages/AnomaliasPage';
import EmpleadoProductividadPage from './pages/EmpleadoProductividadPage';
import SincronizacionPage from './pages/SincronizacionPage';
import ConfiguracionPage from './pages/ConfiguracionPage';
import TurnosPage from './pages/TurnosPage';
import ContratosPage from './pages/ContratosPage';
import AdminPage from './pages/AdminPage';
import AyudaPage from './pages/AyudaPage';
import TrazabilidadPage from './pages/TrazabilidadPage';
import NotificacionesPage from './pages/NotificacionesPage';
import ReportesPage from './pages/ReportesPage';
import { Toaster } from './components/ui/sonner';

const API = process.env.REACT_APP_BACKEND_URL;

function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [syncStatus, setSyncStatus] = useState(null);
  const { apiFetch } = useAuth();
  const { t } = useLang();

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await apiFetch('/api/sync/status');
        if (res.ok) setSyncStatus(await res.json());
      } catch {}
    };
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000);
    return () => clearInterval(interval);
  }, [apiFetch]);

  return (
    <div style={{ display: 'flex', height: '100vh', background: '#0f172a', overflow: 'hidden' }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} syncStatus={syncStatus} />
      <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/fichajes" element={<FichajesPage />} />
          <Route path="/empleados" element={<EmpleadosPage />} />
          <Route path="/analisis" element={<AnalisisPage />} />
          <Route path="/anomalias" element={<AnomaliasPage />} />
          <Route path="/empleados/:empId/productividad" element={<EmpleadoProductividadPage />} />
          <Route path="/contratos" element={<ContratosPage />} />
          <Route path="/turnos" element={<TurnosPage />} />
          <Route path="/notificaciones" element={<NotificacionesPage />} />
          <Route path="/sync" element={<SincronizacionPage syncStatus={syncStatus} />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/config" element={<ConfiguracionPage />} />
          <Route path="/ayuda" element={<AyudaPage />} />
          <Route path="/trazabilidad" element={<TrazabilidadPage />} />
          <Route path="/reportes" element={<ReportesPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
      <FeedbackButton />
    </div>
  );
}

function AuthGuard({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#0f172a' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '3px solid #1e293b', borderTop: '3px solid #60a5fa', borderRadius: '50%', margin: '0 auto 16px', animation: 'spin 1s linear infinite' }} />
          <p style={{ color: '#64748b', fontFamily: 'IBM Plex Mono', fontSize: '13px' }}>SmartClockIn...</p>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={
          <AuthGuard>
            <AppLayout />
          </AuthGuard>
        } />
      </Routes>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}
